// AuthContext.js
import React, { useEffect, useState } from 'react';
import localStorageTemplates from 'common/local-storage-templates';
import queryString from 'query-string';
import { useConfig } from 'config.js';
import { readCookie, readToken } from 'utils/readToken';

export const AuthContext = React.createContext();

export default ({ children }) => {
  const { config } = useConfig();
  const { ZI_COOKIE } = config;
  
  const getAuthToken = () => {
    let token = '';
    if (window.location.host.includes('zoominfo.com')) {
      token = readCookie(ZI_COOKIE);
    } else {
      token = readToken();
    }
    return token;
  };

  const searchParams = queryString.parse(window.location.search);
  const isChatOnly = searchParams['chat_only'] && searchParams['chat_only'] === 'true';
  const isTeamsOnlyToken = localStorage.getItem(localStorageTemplates.teamsOnlyToken) || false;
  const {
    tenant: tenantId,
    group: teamId,
    channelId,
    userObjectId,
    userPrincipalName,
  } = searchParams;
  const isTeamsParamsPresent = tenantId && teamId && channelId && userObjectId && userPrincipalName;

  const prevAuth =
    (!isChatOnly && isTeamsOnlyToken) || (isTeamsOnlyToken && !isTeamsParamsPresent)
      ? ''
      : getAuthToken();

  const [authenticated, setAuthenticated] = useState(prevAuth);

  useEffect(() => {
    if (authenticated) {
      if (!window.location.host.includes('zoominfo.com')) {
        localStorage.setItem(localStorageTemplates.insentPublisherLoginToken, authenticated);
      }
    }
  }, [authenticated]);

  const logOut = () => {
    try {
      setAuthenticated('');
      localStorage.clear();
      window.insent.widget('hide');
    } catch (e) {
      // insent not initialized
    }
  };

  const defaultContext = {
    authenticated,
    setAuthenticated,
    logOut,
  };
  return <AuthContext.Provider value={defaultContext}>{children}</AuthContext.Provider>;
};
